import React from 'react';
import { ErrorLabel } from '@eika/label';
const ErrorMessage = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, text ? /*#__PURE__*/React.createElement(ErrorLabel, {
    text: text,
    "aria-roledescription": "alert",
    className: "input-error-message"
  }) : undefined);
};
export default ErrorMessage;